<template>
    <section id="account-trial">
        <h3 class="text-uppercase mt-4">Subscription and billing</h3>
        <hr class="bar my-3" />

        <div>
            <p class="font-weight-bold mb-0">
                Trial Expiration Date: {{ moment(subscription.trial_ends_at).format("MM/DD/YYYY") }}
            </p>
        </div>

        <div class="bg-white border-light p-3 mt-2">
            <h5>Select your billing cycle:</h5>

            <fieldset class="form-group mb-0">
                <div class="d-flex mb-4">
                    <div
                        class="pricing-plan bg-white py-3 px-2 m-2 cursor-pointer position-relative"
                        @click="changePlan(p.id)"
                        v-for="p in monthlyPlans"
                    >
                        <h4 class="font-weight-bold">
                            <i
                                class="fa fa-lg mr-3"
                                :class="
                                    p.id === plan ? 'fa-dot-circle-o text-primary' : 'fa-circle-o'
                                "
                            ></i>
                            <span class="text-capitalize">{{ `${p.interval}ly` }}</span>
                        </h4>
                        <span
                            v-if="p.interval === 'year'"
                            class="save-tag px-2 small font-weight-bold"
                            >Save 37%</span
                        >
                        <p v-if="p.interval === 'year'" class="mb-0">
                            US${{ (p.amount / 12).toFixed(2) }}/month
                        </p>
                        <p v-else="" class="mb-0">&nbsp;</p>
                        <p class="mb-0">
                            Billed {{ `${p.interval}ly` }} for US${{ p.amount.toFixed(2) }}
                        </p>
                    </div>
                </div>
            </fieldset>

            <coupon-widget
                :user="user"
                :subscription="subscription"
                @valid-coupon="changeCoupon($event)"
                @invalid-coupon="coupon = null"
            ></coupon-widget>

            <div class="row">
                <div class="col-12 col-8-sm my-2">
                    <label><b>Cardholder name</b></label>
                    <input
                        id="cardholder-name"
                        v-model="cardholderName"
                        class="form-control mb-3"
                        placeholder="Cardholder name"
                    />
                    <span><b>Card Information</b></span>
                    <div id="stripe-card-subscribe" class="form-control"></div>
                </div>
            </div>

            <div class="w-100 d-flex justify-content-end">
                <button
                    @click.prevent="checkoutSubscribe()"
                    id="subscribe-gt"
                    class="text-uppercase btn btn-sm btn-primary text-white"
                >
                    Subscribe
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import CouponWidget from "../widgets/CouponWidget";

export default {
    name: "AccountTrial",
    props: ["user", "subscription", "plans", "isStripeMounted", "intent"],
    components: { CouponWidget },
    data() {
        return {
            cardholderName: "",
            coupon: null,
            plan: "",
        };
    },
    mounted() {
        if (!this.isStripeMounted) {
            helpers.mountStripeElement("stripe-card-subscribe");
            this.$emit("stripe-mounted");
        }
    },
    watch: {
        plans() {
            if (this.plans && this.plans.length && !this.plan) {
                const monthlyPlan = this.plans.find(plan => plan.interval === "month");
                this.plan = monthlyPlan.id;
            }
        },
    },
    computed: {
        monthlyPlans() {
            return this.plans.filter(plan => plan.interval === "month");
        },
    },
    methods: {
        changePlan(planId) {
            this.plan = planId;
        },

        changeCoupon(coupon) {
            this.coupon = coupon;
        },

        async checkoutSubscribe() {
            helpers.toggleSpinner("subscribe-gt");

            const { setupIntent, error } = await stripe.handleCardSetup(
                this.intent.client_secret,
                card,
                {
                    payment_method_data: {
                        billing_details: { name: this.cardholderName },
                    },
                }
            );

            if (error) {
                helpers.toggleSpinner("upgrade");
                this.$swal("Error", `Something went wrong authorizing your card.`, "error");
            } else {
                this.createSubscription(setupIntent);
            }
        },

        createSubscription(setupIntent) {
            let payload = {
                setupIntent,
                plan: this.plan,
                cardholderName: this.cardholderName,
            };
            if (this.coupon) {
                payload.coupon = this.coupon;
            }
            axios
                .post(`/api/users/${this.user.id}/subscription/new`, payload)
                .then(r => {
                    mixpanel.track(
                        `Subscribe - Swap to ${this.plans.find(p => p.id === this.plan).nickname}`
                    );
                    helpers.toggleSpinner("subscribe-gt");
                    window.location.href = "/account-settings"; //Reload the page to prevent stripe elements from conflicting with another instance.
                })
                .catch(e => {
                    helpers.toggleSpinner("subscribe-gt");
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped>
.pricing-plan {
    border: solid 1px #d64571;
    flex-basis: 0;
    flex-grow: 1;
}
.save-tag {
    position: absolute;
    right: -1rem;
    top: 1rem;
    z-index: 2;
    background-color: #fff1c3;
}
</style>
